module.exports = {
	UPLOAD_MEDIA_API: "https://mediaupload.sharechat.com/uploadFile",
	JEET11_API: "https://api.staging.jeet11.com",
	DEFAULT_ERROR_MESSAGE: "Something is not right...",
	DASHBOARD_LAMBDA_API:
		"https://yxkvd37cra.execute-api.ap-south-1.amazonaws.com/prod",
	APP_MAIN_API: "https://restapi1.sharechat.com",
	TOP: "top",
	END: "end",
	SEARCH: "search",
	razorPayMTGPLKey: "rzp_live_aYMlhlTmco5fx4",
	logo: "hello",
	JEET_11_PARTNER: "Jeet11 Retailer",
	JEET_11_DISTRIBUTOR: "Jeet11 Distributor",
	JEET_11_EXECUTIVE: "Jeet11 Executive",
	JEET_11_CAPTAIN: "Jeet11 Captain",
	JEET_11_PROMOTER: "Jeet11 Promoter",
	JEET_11_TSM: "Jeet11 TSM",
	JEET_11_RBM: "Jeet11 RBM",
	JEET_11_AGENT: "Jeet11 Agent",
	JEET_11_SHOPBOY: "Jeet11 Shopboy",
	JEET_11_ONLINE_DSTR: "Jeet11 Distributor Online",
	JEET_11_ONLINE_RETAILER: "Jeet11 Retailer Online",
	JEET_11_ONLINE_EXECUTIVE: "Jeet11 Executive Online",
	JEET_11_CDN_BASE_LINK: "https://cdn.jeet11.com/retail-tool"
};
